import React, { PureComponent } from 'react';
import cn from 'classname';

import includes from 'lodash/includes';

import withIntl from '../../shared/intl-hoc';

class TableBody extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			selected: []
		};
	}

	select(mailingSplitTestId) {
		this.setState(({ selected }) => ({
			selected: includes(selected, mailingSplitTestId)
				? selected.filter((id) => id !== mailingSplitTestId)
				: selected.concat(mailingSplitTestId)
		}));
	}

	getRows() {
		const { intl, rows, row: MailingRow, subRow: MailingSubRow, removeBySplitTestId } = this.props;

		return rows.reduce((rows, mailing) => {
			const isOpen = includes(this.state.selected, mailing.split_test_id);

			rows.push((
				<MailingRow
					className='mailings-new-list-row'
					mailing={mailing}
					onClick={() => this.select(mailing.split_test_id)}
					removeBySplitTestId={(id) => {
						if (confirm(intl('Remove mailing?'))) {
							removeBySplitTestId(id);
						}
					}}
					key={`m-${mailing.split_test_id}`}
				/>
			));

			rows.push(mailing.list.map((template, index, children) => (
				<MailingSubRow
					className={cn('mailings-new-list-sub-row', {
						'mailings-new-list-sub-row-opened': isOpen,
						'mailings-new-list-sub-row-first': index === 0,
						'mailings-new-list-sub-row-last': index === children.length - 1
					})}
					template={template}
					key={`t-${template.id}`}
				/>
			)));

			return rows;
		}, []);
	}

	render() {
		return (
			<tbody className='new-table__body'>
				{this.getRows()}
			</tbody>
		);
	}
}

export default withIntl(TableBody);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/components/table-body.js